import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const TEAM_IMG = "https://images.pexels.com/photos/3861563/pexels-photo-3861563.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const DC_IMG = "https://images.unsplash.com/photo-1584169417032-d34e8d805e8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxkYXRhJTIwY2VudGVyJTIwZW50ZXJwcmlzZXxlbnwwfHx8fDE3ODEyNjk0OTl8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="border-b border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
            <div className="md:col-span-7">
              <div className="overline">About Sunsri</div>
              <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.05] mt-6 text-[#0F172A]">
                Senior SAP people, <br />uncommon clarity.
              </h1>
              <p className="text-lg text-gray-600 mt-8 max-w-xl leading-relaxed">
                Sunsri Software Private Limited was founded by SAP architects who were tired of staffing pyramids and ambiguous statements of work. We rebuilt the consultancy from first principles.
              </p>
            </div>
            <div className="md:col-span-5">
              <img src={TEAM_IMG} alt="Team collaborating" className="w-full h-[420px] object-cover editorial-img" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <div className="overline">Our principles</div>
          </div>
          <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-10">
            {[
              { t: "Senior-led delivery", d: "Architects in every room. No silent benches." },
              { t: "Outcome over output", d: "We track value, not story points." },
              { t: "Editorial clarity", d: "Every document, plan and presentation written like it matters." },
              { t: "Long-term partnership", d: "Most of our clients have been with us for more than five years." },
            ].map((p, i) => (
              <Reveal key={p.t} delay={i * 80}>
                <div className="border-t border-[#111827] pt-6">
                  <div className="font-serif text-2xl text-[#0F172A]">{p.t}</div>
                  <p className="text-gray-600 mt-3 leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 sm:py-32 bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-6">
            <img src={DC_IMG} alt="Enterprise data center" className="w-full h-[480px] object-cover editorial-img" />
          </div>
          <div className="md:col-span-6">
            <div className="overline">By the numbers</div>
            <h2 className="font-serif text-4xl sm:text-5xl mt-5 text-[#0F172A] leading-tight">A decade of SAP delivery — and counting.</h2>
            <div className="grid grid-cols-3 gap-8 mt-10">
              {[
                { k: "60+", v: "Senior consultants" },
                { k: "10+", v: "Countries" },
                { k: "98%", v: "AMS SLA" },
              ].map((s) => (
                <div key={s.v} className="border-l-2 border-[#111827] pl-5">
                  <div className="font-serif text-4xl text-[#0F172A]">{s.k}</div>
                  <div className="overline mt-1">{s.v}</div>
                </div>
              ))}
            </div>
            <Link to="/contact" data-testid="about-cta" className="btn-primary mt-12">
              Speak with leadership <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
